import { Footer, Link, Text } from "basis";
import { STATIC_RESOURCES } from "constants/contacts";
import { getRegional } from "library/getRegional";
import { useEventTracking } from "react-event-tracker";

const { tncPdfAu } = STATIC_RESOURCES;
const { tncPdfNz } = STATIC_RESOURCES;

const MyFooter = () => {
  const isNZ = getRegional("code") === "NZ";
  const socialLinks = getRegional("footerSocialLinks");
  const { facebook, youtube, twitter, instagram, linkedin } = socialLinks;
  const legalLinks = getRegional("footerLegalLinks");
  const privacyHref = legalLinks.find(
    (link) => link.text === "Privacy and Credit Reporting Policy",
  )?.href;

  const { trackEvent, getQueryString } = useEventTracking();

  return (
    <Footer>
      <Footer.Header>
        <Footer.Header.Logo name={isNZ ? "gem" : "latitude"} />
        <Footer.Header.Social>
          {facebook && (
            <Footer.Header.Social.Facebook
              testId="facebook"
              onClick={() =>
                trackEvent({
                  event: {
                    category: "text-link",
                    action: "social-link",
                    label: "facebook",
                    location: "footer",
                  },
                })
              }
              {...facebook}
            />
          )}
          {youtube && (
            <Footer.Header.Social.YouTube
              testId="youtube"
              onClick={() =>
                trackEvent({
                  event: {
                    category: "text-link",
                    action: "social-link",
                    label: "youtube",
                    location: "footer",
                  },
                })
              }
              {...youtube}
            />
          )}
          {twitter && (
            <Footer.Header.Social.Twitter
              testId="twitter"
              onClick={() =>
                trackEvent({
                  event: {
                    category: "text-link",
                    action: "social-link",
                    label: "twitter",
                    location: "footer",
                  },
                })
              }
              {...twitter}
            />
          )}
          {instagram && (
            <Footer.Header.Social.Instagram
              testId="instagram"
              onClick={() =>
                trackEvent({
                  event: {
                    category: "text-link",
                    action: "social-link",
                    label: "instagram",
                    location: "footer",
                  },
                })
              }
              {...instagram}
            />
          )}
          {linkedin && (
            <Footer.Header.Social.LinkedIn
              testId="linkedin"
              onClick={() =>
                trackEvent({
                  event: {
                    category: "text-link",
                    action: "social-link",
                    label: "linkedin",
                    location: "footer",
                  },
                })
              }
              {...linkedin}
            />
          )}
        </Footer.Header.Social>
      </Footer.Header>
      <Footer.Legal>
        <Footer.Legal.Links>
          <Link
            href={isNZ ? tncPdfNz : tncPdfAu}
            newTab
            onClick={() =>
              trackEvent({
                event: {
                  category: "text-link",
                  action: "internal-link",
                  location: "footer",
                  label: "Terms and conditions",
                },
              })
            }
          >
            Terms and conditions
          </Link>
          {legalLinks.map(({ text, href, eventData }) => (
            <Link
              href={`${href}?${getQueryString({ event: eventData })}`}
              newTab
              key={text}
              onClick={() => trackEvent({ event: eventData })}
            >
              {text}
            </Link>
          ))}
        </Footer.Legal.Links>
        {!isNZ && (
          <Footer.Legal.Copy>
            <Text>
              The Latitude Group recommends that you read the{" "}
              <Link
                href={`${isNZ ? tncPdfNz : tncPdfAu}?${getQueryString({
                  event: {
                    category: "text-link",
                    action: "internal-link",
                    location: "footer-text",
                    label: "Terms and conditions",
                  },
                })}`}
                newTab
                onClick={() => ({
                  event: {
                    category: "text-link",
                    action: "internal-link",
                    location: "footer-text",
                    label: "Terms and conditions",
                  },
                })}
              >
                Terms and conditions
              </Link>
              {" and "}
              <Link
                href={`${privacyHref}?${getQueryString({
                  event: {
                    category: "text-link",
                    action: "internal-link",
                    location: "footer-text",
                    label: "Privacy and Credit Reporting Policy",
                  },
                })}`}
                newTab
                onClick={() =>
                  trackEvent({
                    event: {
                      category: "text-link",
                      action: "internal-link",
                      location: "footer-text",
                      label: "Privacy and Credit Reporting Policy",
                    },
                  })
                }
              >
                Privacy and Credit Reporting Policy
              </Link>{" "}
              of the website. The Latitude Group is a leader in consumer finance
              in Australia and New Zealand offering a range of services:
              including personal loans, car loans, credit cards, personal
              insurance, interest free and promotional retail. In Australia, the
              Latitude Group includes: Latitude Financial Services Australia
              Holdings Pty Ltd (ABN 46 603 161 100); Latitude Finance Australia
              (ABN 42 008 583 588 Australian Credit Licence Number 392145);
              Latitude Personal Finance Pty Ltd (ABN 54 008 443 810 Australian
              Credit Licence Number 392163) and Latitude Automotive Financial
              Services (ABN 80 004 187 419 Australian Credit Licence Number
              392178) trading as Latitude Financial Services. In New Zealand,
              the Latitude Group includes: Latitude Financial Services Limited
              (Company number 5624865). Latitude Financial Services 800 Collins
              Street, Docklands, Victoria 3008.
            </Text>
          </Footer.Legal.Copy>
        )}
        {isNZ && (
          <Footer.Legal.Copy>
            <Text>
              Gem is a leader in consumer finance, offering a range of services
              including personal loans, car loans, credit cards, interest free
              and promotional retail finance. Gem products are provided by{" "}
              <Link
                href="https://www.gemfinance.co.nz/about-us/"
                newTab
                onClick={() =>
                  trackEvent({
                    event: {
                      category: "text-link",
                      action: "internal-link",
                      location: "footer-text",
                      label: "Latitude Financial Services Limited",
                    },
                  })
                }
              >
                Latitude Financial Services Limited
              </Link>
              . Gem New Zealand, 8 Tangihua Street, Auckland, 1010, New Zealand.
            </Text>
          </Footer.Legal.Copy>
        )}
      </Footer.Legal>
    </Footer>
  );
};

export { MyFooter as Footer };
